import * as React from "react";
import { Button, Popover, PopoverSurface, PopoverTrigger, Text, makeStyles } from "@fluentui/react-components";

const useStyles = makeStyles({
  surface: {
    minWidth: "280px",
    maxWidth: "520px",
    display: "grid",
    gap: "8px",
  },
  content: {
    display: "grid",
    gap: "6px",
  },
  icon: {
    display: "block",
  },
});

export interface InfoPopoverControlProps {
  title?: string;
  children: React.ReactNode;
}

export function InfoPopoverControl({ title = "Details", children }: InfoPopoverControlProps): JSX.Element {
  const styles = useStyles();

  const icon = (
    <svg
      className={styles.icon}
      width="14"
      height="14"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.8" />
      <path d="M12 10.4V17" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
      <circle cx="12" cy="7.5" r="1" fill="currentColor" />
    </svg>
  );

  return (
    <Popover openOnHover positioning="below-end">
      <PopoverTrigger disableButtonEnhancement>
        <Button appearance="subtle" icon={icon} aria-label="Show entity info" title="Show entity info" />
      </PopoverTrigger>

      <PopoverSurface className={styles.surface}>
        <Text weight="semibold">{title}</Text>
        <div className={styles.content}>{children}</div>
      </PopoverSurface>
    </Popover>
  );
}